export const formatPrice = (price, zeros = 2) => {
    return price.toFixed(zeros);
}

export const priceString = (price, zeros = 2) => {
    return `$${price.toFixed(zeros)}`;
}